import React from 'react'
import styles from './index.module.less'
import classNames from 'classnames'

interface TitleProps {
  children?: React.ReactNode
  className?: string
}

export default function Title({ children, className }: TitleProps) {
  return (
    <p
      className={classNames(styles.title, className)}
      title={children as string}
    >
      {children}
    </p>
  )
}
